import { render, staticRenderFns } from "./CurrentProjects.vue?vue&type=template&id=153c2a39&scoped=true"
import script from "./CurrentProjects.vue?vue&type=script&lang=js"
export * from "./CurrentProjects.vue?vue&type=script&lang=js"
import style0 from "./CurrentProjects.vue?vue&type=style&index=0&id=153c2a39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153c2a39",
  null
  
)

export default component.exports